import React, { useState } from 'react';
import toast from 'react-hot-toast';

const QualityCheckModal = ({ isOpen, onClose, onSubmit }) => {
  const [qualityCheck, setQualityCheck] = useState(null);
  const [description, setDescription] = useState('');

  const handleSinkRemarkClick = (remark) => {
    setQualityCheck(remark);
  };

  const handleSubmit = () => {
    if (qualityCheck ==='no' && !description) {
      toast.error("Please add a description if quality check is No", { duration: 3000 });
      return;
    }
    toast.success('Submitted Successfully!', { duration: 3000 });
    onSubmit( qualityCheck, description );
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-70 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
        <h2 className="text-xl poppins-semibold text-gray-800 mb-2">Quality Check</h2>
        <p className="text-gray-600 poppins-medium">Is the quality is Good?</p>

        <div className="flex space-x-4 my-6">
          {['yes', 'no'].map((option) => (
            <div
              key={option}
              onClick={() => handleSinkRemarkClick(option)}
              className={`cursor-pointer px-6 py-2 rounded-full border transition-colors duration-200
                ${qualityCheck === option ? 'bg-black text-white' : 'bg-white text-gray-800 border-gray-300'}
                hover:bg-gray-200`}
            >
              
              {option}
            </div>
          ))}
        </div>

        {qualityCheck === 'no' && (
          <div className="mb-4">
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Add a description"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )}

        <div className="flex justify-end space-x-3">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition duration-200"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-black text-white rounded-md   transition duration-200"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default QualityCheckModal;
